var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center"}),_c('hello-world',{attrs:{"msg":"Emil Österlund"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }